<template>
  <div class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sticky-lg modal-fullscreen">
      <div class="modal-content rounded">
        <div style="height: 10vh" class="modal-header border-gray-500 shadow-sm">
          <h2>{{ modalInfo.status ? 'Create' : 'Edit' }} lessons</h2>
          <div class="btn btn-icon btn-sm btn-active-icon-primary" @click="closeModal">
            <span class="svg-icon svg-icon-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                  fill="black" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
              </svg>
            </span>
          </div>
        </div>
        <div style="height: 80vh;" class="modal-body d-flex flex-row justify-content-between scroll-y">
          <div class="p-2 col-3 h-100 scroll-y" style="border-left: 1px solid #000;">
            <h3 class="p-2" style="border-bottom: 1px solid #000;">
              Table of contents
            </h3>
            <div class="py-2 px-3">
              <div v-for="(step, index) in hafezliNewObj.steps" :key="step">
                <fieldset class="mb-4" v-if="index > 0">
                  <legend class="d-flex flex-row justify-content-between align-items-center">
                    <h4 class="col-6 m-0">{{ step.title }} - {{ index }}</h4>
                    <div class="d-flex flex-row gap-1 justify-content-end col-6">
                      <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                        @click="addHafezliSteps_New(index)"></button>
                      <button v-if="index > 1" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                        @click="deleteHafezliSteps_New(index)"></button>
                    </div>
                  </legend>
                  <button v-for="session in step.sessions" :key="session" class="w-100 btn mb-4"
                    :class="hafezliNewObj.curStep == `${index}-${session.name}` ? 'btn-primary' : 'btn-secondary'"
                    @click="changeHafezliStep_New(`${index}-${session.name}`)">
                    {{ session.title }}
                  </button>
                </fieldset>
                <button v-else class="w-100 btn mb-2"
                  :class="hafezliNewObj.curStep == index ? 'btn-primary' : 'btn-secondary'"
                  @click="changeHafezliStep_New('0-lesson')">
                  {{ step.title }}
                </button>
              </div>
            </div>
          </div>
          <div class="h-100 col-9 px-7 d-flex flex-column justify-content-start align-items-center">
            <div v-if="hafezliNewObj.curStep.includes('lead')" class="w-100 scroll-y">
              <div class="mt-5 d-flex justify-content-between">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Lock status
                </label>
                <input class="form-check-input w-20px h-20px end alig ms-10" type="checkbox"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.lock" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Activity title
                </label>
                <input class="form-control form-control-solid p-4" type="text"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.title" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Summary of activity {{ hafezliCurStepIndex }}
                </label>
                <textarea class="form-control form-control-solid p-4" rows="2"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.summary"></textarea>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Description
                </label>
                <editor v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.description" :api-key="tinymceToken"
                  :init="{
                    menubar:
                      field && field.menubar
                        ? field.menubar
                        : tinyMCE_Def.menubar,
                    plugins:
                      field && field.plugins
                        ? field.plugins
                        : tinyMCE_Def.plugins,
                    directionality:
                      field && field.directionality
                        ? field.directionality
                        : tinyMCE_Def.directionality,
                    toolbar:
                      field && field.toolbar
                        ? field.toolbar
                        : tinyMCE_Def.toolbar,
                    height:
                      field && field.minHeight
                        ? field.minHeight
                        : tinyMCE_Def.minHeight,
                  }" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Upload photos \ videos \ voices
                </label>
                <div @click="
                  setModalConfigs('choose', {
                    root: 'files',
                    depth: 1,
                    child: 'lead',
                    index: hafezliCurStepIndex
                  })
                  " class="fv-row">
                  {{ hafezliNewObj.info[hafezliCurStepIndex].lead.files }}
                  <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                    id="kt_dropzonejs_example_1">
                    <div v-if="
                      hafezliNewObj.info[hafezliCurStepIndex].lead.files &&
                      hafezliNewObj.info[hafezliCurStepIndex].lead.files.length > 0
                    " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                      <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].lead.files" :key="photo"
                        class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                        <div class="symbol symbol-100px">
                          <!-- <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                          /> -->
                          <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                        </div>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[0]
                            : photo["filename"]
                              ? photo["filename"].split(".")[0]
                              : "???"
                        }}</label>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[1].toUpperCase()
                            : photo["filename"]
                              ? photo["filename"].split(".")[1].toUpperCase()
                              : "???"
                        }}</label>
                      </div>
                    </div>
                    <div v-else
                      class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                      <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                      <div class="ms-4">
                        <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                          Click to select your files
                        </h3>
                        <span class="fs-7 fw-bold text-gray-400">Max files: 10</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Quizes part
                </label>
                <div class="d-flex flex-center flex-column gap-3">
                  <fieldset class="w-100 mt-5" v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].lead.quizes"
                    :key="qi">
                    <legend class="d-flex flex-row justify-content-between align-items-center">
                      <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                      <div class="d-flex flex-row gap-1 justify-content-end col-6">
                        <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                          @click="addHafezliQuiz_New('lead', qi)"></button>
                        <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                          @click="deleteHafezliQuiz_New('lead', qi)"></button>
                      </div>
                    </legend>
                    <div>
                      <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                        menubar:
                          field && field.menubar
                            ? field.menubar
                            : tinyMCE_Def.menubar,
                        plugins:
                          field && field.plugins
                            ? field.plugins
                            : tinyMCE_Def.plugins,
                        directionality:
                          field && field.directionality
                            ? field.directionality
                            : tinyMCE_Def.directionality,
                        toolbar:
                          field && field.toolbar
                            ? field.toolbar
                            : tinyMCE_Def.toolbar,
                        height:
                          field && field.minHeight
                            ? field.minHeight
                            : tinyMCE_Def.minHeight,
                      }" />
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Tip of question {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['summary']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer reference of question {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['reference']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer type
                      </label>
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                        :options="hafezliNewObj.objects.quiz">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div v-if="q.type == 'clozeTest'">
                      Fill in answers as the order of blanks. In the user view the system will radomize it automatically.
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'blank'">
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'matching'">
                      <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                        v-for="(a, ai) in q['answer']" :key="ai">
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == 'shortAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == 'longAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == '2choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '3choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">
                                  Click to select your files
                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '4choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 3
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][3]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][3]" />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <!-- <div class="mt-5 d-flex justify-content-between">
                <label class="fs-5 fw-bolder form-label mb-2">
                  آیا زبان آموز باید پاسخی را ثبت کند؟
                </label>
                <input class="form-check-input w-20px h-20px end alig ms-10" type="checkbox"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.question" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
              <!-- <div v-if="hafezliNewObj.info[hafezliCurStepIndex].lead.question" class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  نوع پاسخ زبان‌آموز را انتخاب نمایید
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].lead.ansType"
                  :options="hafezliNewObj.objects.general">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
            </div>
            <div v-else-if="hafezliNewObj.curStep.includes('tasks')" class="w-100 scroll-y">
              <fieldset class="mt-5" v-for="(t, ti) in hafezliNewObj.info[hafezliCurStepIndex].tasks" :key="ti">
                <legend class="d-flex flex-row justify-content-between align-items-center p-2 rounded"
                  :class="hafezliNewObj.curTask == ti ? 'bg-primary' : 'bg-secondary'">
                  <h4 class="col-6 m-0">Task - {{ ti + 1 }}</h4>
                  <div class="d-flex flex-row gap-1 justify-content-end col-6">
                    <button class="btn btn-dark btn-sm btn-icon" @click="collapseHafezliTask_New(ti)"
                      :class="hafezliNewObj.curTask == ti ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></button>
                    <button class="btn btn-success btn-sm btn-icon bi bi-plus" @click="addHafezliTask_New(ti)"></button>
                    <button v-if="ti > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                      @click="deleteHafezliTask_New(ti)"></button>
                  </div>
                </legend>
                <div :class="hafezliNewObj.curTask == ti ? 'd-block' : 'd-none'">
                  <div class="mt-5">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Description of Tasks
                    </label>
                    {{ field && field.minHeight
                      ? field.minHeight
                      : tinyMCE_Def.minHeight }}
                    <editor v-model="t['description']" :api-key="tinymceToken" :init="{
                      menubar:
                        field && field.menubar
                          ? field.menubar
                          : tinyMCE_Def.menubar,
                      plugins:
                        field && field.plugins
                          ? field.plugins
                          : tinyMCE_Def.plugins,
                      directionality:
                        field && field.directionality
                          ? field.directionality
                          : tinyMCE_Def.directionality,
                      toolbar:
                        field && field.toolbar
                          ? field.toolbar
                          : tinyMCE_Def.toolbar,
                      height: tinyMCE_Def.minHeight,
                    }" />
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                  <div class="mt-5">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Photos/ Videos / Audios
                    </label>
                    <div @click="
                      setModalConfigs('choose', {
                        root: 'files',
                        depth: 2,
                        child: 'tasks',
                        index: hafezliCurStepIndex,
                        childIndex: ti
                      })
                      " class="fv-row">
                      {{ hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files }}
                      <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                        id="kt_dropzonejs_example_1">
                        <div v-if="
                          hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files &&
                          hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files.length > 0
                        " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                          <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].files" :key="photo"
                            class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                            <div class="symbol symbol-100px">
                              <!-- <img
                                :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                              /> -->
                              <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                            </div>
                            <label for="">{{
                              typeof photo == "string"
                                ? photo.split(".")[0]
                                : photo["filename"]
                                  ? photo["filename"].split(".")[0]
                                  : "???"
                            }}</label>
                            <label for="">{{
                              typeof photo == "string"
                                ? photo.split(".")[1].toUpperCase()
                                : photo["filename"]
                                  ? photo["filename"].split(".")[1].toUpperCase()
                                  : "???"
                            }}</label>
                          </div>
                        </div>
                        <div v-else
                          class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                          <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                          <div class="ms-4">
                            <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                            </h3>
                            <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                  <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                    <label class="fs-5 fw-bolder form-label mb-2">
                      Quizes
                    </label>
                    <div class="d-flex flex-center flex-column gap-3">
                      <fieldset class="w-100 mt-5"
                        v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].tasks[ti].quizes" :key="qi">
                        <legend class="d-flex flex-row justify-content-between align-items-center">
                          <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                          <div class="d-flex flex-row gap-1 justify-content-end col-6">
                            <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                              @click="addHafezliQuiz_New(ti, qi)"></button>
                            <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                              @click="deleteHafezliQuiz_New(ti, qi)"></button>
                          </div>
                        </legend>
                        <div>
                          <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                            menubar:
                              field && field.menubar
                                ? field.menubar
                                : tinyMCE_Def.menubar,
                            plugins:
                              field && field.plugins
                                ? field.plugins
                                : tinyMCE_Def.plugins,
                            directionality:
                              field && field.directionality
                                ? field.directionality
                                : tinyMCE_Def.directionality,
                            toolbar:
                              field && field.toolbar
                                ? field.toolbar
                                : tinyMCE_Def.toolbar,
                            height:
                              field && field.minHeight
                                ? field.minHeight
                                : tinyMCE_Def.minHeight,
                          }" />
                        </div>
                        <div class="mt-5">
                          <label class="fs-5 fw-bolder form-label mb-2">
                            Tip {{ qi + 1 }}
                          </label>
                          <textarea class="form-control form-control-solid p-4" rows="2"
                            v-model="q['summary']"></textarea>
                          <div class="invalid-feedback d-none">متن خطا</div>
                        </div>
                        <div class="mt-5">
                          <label class="fs-5 fw-bolder form-label mb-2">
                            Answer reference of question {{ qi + 1 }}
                          </label>
                          <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['reference']"></textarea>
                          <div class="invalid-feedback d-none">متن خطا</div>
                        </div>
                        <div class="mt-5">
                          <label class="fs-5 fw-bolder form-label mb-2">
                            Answer type
                          </label>
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                            :options="hafezliNewObj.objects.quiz">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div class="invalid-feedback d-none">متن خطا</div>
                        </div>
                        <div v-if="q.type == 'clozeTest'">
                          
                          <input v-for="(a, ai) in q['answer']" :key="ai"
                            class="form-control form-control-solid p-4 mt-2" type="text"
                            :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                        </div>
                        <div v-else-if="q.type == 'blank'">
                          <input v-for="(a, ai) in q['answer']" :key="ai"
                            class="form-control form-control-solid p-4 mt-2" type="text"
                            :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                        </div>
                        <div v-else-if="q.type == 'matching'">
                          <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                            v-for="(a, ai) in q['answer']" :key="ai">
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == 'shortAns'">
                          <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                            v-model="q['answer'][0]" />
                        </div>
                        <div v-else-if="q.type == 'longAns'">
                          <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                            v-model="q['answer'][0]" />
                        </div>
                        <div v-else-if="q.type == '2choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == '3choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 2
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][2]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][2]" />
                          </div>
                        </div>
                        <div v-else-if="q.type == '4choices'">
                          <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                            class="form-control form-control-solid cursor-pointer mt-2" label="title"
                            v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                            <template v-slot:option="{ option }">
                              {{ option.title }}
                            </template>
                          </multiselect>
                          <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quizes',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 0
                              })
                              " class="fv-row">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][0]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 1
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][1]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 2
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][2]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div @click="
                              setModalConfigs('choose', {
                                root: 'files',
                                depth: 2,
                                child: 'tasks',
                                index: hafezliCurStepIndex,
                                subChild: 'quiz',
                                childIndex: ti,
                                subIndex: qi,
                                elIndex: 3
                              })
                              " class="fv-row mt-2">
                              <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                                id="kt_dropzonejs_example_1">
                                <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                                  class="d-flex flex-center flex-wrap scroll-y mh-200px">
                                  <div v-for="photo in q['answer'][3]" :key="photo"
                                    class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                    <div class="symbol symbol-100px">
                                      <!-- <img
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                    /> -->
                                      <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                    </div>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[0]
                                        : photo["filename"]
                                          ? photo["filename"].split(".")[0]
                                          : "???"
                                    }}</label>
                                    <label for="">{{
                                      typeof photo == "string"
                                        ? photo.split(".")[1].toUpperCase()
                                        : photo["filename"]
                                          ? photo["filename"]
                                            .split(".")[1]
                                            .toUpperCase()
                                          : "???"
                                    }}</label>
                                  </div>
                                </div>
                                <div v-else
                                  class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                                  <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                                  <div class="ms-4">
                                    <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                    </h3>
                                    <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Correct answer`" v-model="q['answer'][0]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][1]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][2]" />
                            <input class="form-control form-control-solid p-4 mt-2" type="text"
                              :placeholder="`Wrong answer`" v-model="q['answer'][3]" />
                          </div>
                        </div>
                      </fieldset>
                    </div>
                    <div class="invalid-feedback d-none">متن خطا</div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div v-else-if="hafezliNewObj.curStep.includes('followUp')" class="w-100 scroll-y">
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Description of follow up
                </label>
                <editor v-model="hafezliNewObj.info[hafezliCurStepIndex].followUp.description" :api-key="tinymceToken"
                  :init="{
                    menubar:
                      field && field.menubar
                        ? field.menubar
                        : tinyMCE_Def.menubar,
                    plugins:
                      field && field.plugins
                        ? field.plugins
                        : tinyMCE_Def.plugins,
                    directionality:
                      field && field.directionality
                        ? field.directionality
                        : tinyMCE_Def.directionality,
                    toolbar:
                      field && field.toolbar
                        ? field.toolbar
                        : tinyMCE_Def.toolbar,
                    height:
                      field && field.minHeight
                        ? field.minHeight
                        : tinyMCE_Def.minHeight,
                  }" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Uploads the files
                </label>
                <div @click="
                  setModalConfigs('choose', {
                    root: 'files',
                    depth: 1,
                    child: 'followUp',
                    index: hafezliCurStepIndex
                  })
                  " class="fv-row">
                  {{ hafezliNewObj.info[hafezliCurStepIndex].followUp.files }}
                  <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                    id="kt_dropzonejs_example_1">
                    <div v-if="
                      hafezliNewObj.info[hafezliCurStepIndex].followUp.files &&
                      hafezliNewObj.info[hafezliCurStepIndex].followUp.files.length > 0
                    " class="d-flex flex-center flex-wrap scroll-y mh-200px">
                      <div v-for="photo in hafezliNewObj.info[hafezliCurStepIndex].followUp.files" :key="photo"
                        class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                        <div class="symbol symbol-100px">
                          <!-- <img
                            :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                          /> -->
                          <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                        </div>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[0]
                            : photo["filename"]
                              ? photo["filename"].split(".")[0]
                              : "???"
                        }}</label>
                        <label for="">{{
                          typeof photo == "string"
                            ? photo.split(".")[1].toUpperCase()
                            : photo["filename"]
                              ? photo["filename"].split(".")[1].toUpperCase()
                              : "???"
                        }}</label>
                      </div>
                    </div>
                    <div v-else
                      class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                      <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                      <div class="ms-4">
                        <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                        </h3>
                        <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5 p-3 rounded border border-1 border-dashed border-gray-600">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Quizes
                </label>
                <div class="d-flex flex-center flex-column gap-3">
                  <fieldset class="w-100 mt-5"
                    v-for="(q, qi) in hafezliNewObj.info[hafezliCurStepIndex].followUp.quizes" :key="qi">
                    <legend class="d-flex flex-row justify-content-between align-items-center">
                      <h4 class="col-6 m-0">Question - {{ qi + 1 }}</h4>
                      <div class="d-flex flex-row gap-1 justify-content-end col-6">
                        <button class="btn btn-success btn-sm btn-icon bi bi-plus"
                          @click="addHafezliQuiz_New('followUp', qi)"></button>
                        <button v-if="qi > 0" class="btn btn-danger btn-sm btn-icon bi bi-trash"
                          @click="deleteHafezliQuiz_New('followUp', qi)"></button>
                      </div>
                    </legend>
                    <div>
                      <editor v-model="q['question']" :api-key="tinymceToken" :init="{
                        menubar:
                          field && field.menubar
                            ? field.menubar
                            : tinyMCE_Def.menubar,
                        plugins:
                          field && field.plugins
                            ? field.plugins
                            : tinyMCE_Def.plugins,
                        directionality:
                          field && field.directionality
                            ? field.directionality
                            : tinyMCE_Def.directionality,
                        toolbar:
                          field && field.toolbar
                            ? field.toolbar
                            : tinyMCE_Def.toolbar,
                        height:
                          field && field.minHeight
                            ? field.minHeight
                            : tinyMCE_Def.minHeight,
                      }" />
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Tip {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['summary']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer reffrence of question {{ qi + 1 }}
                      </label>
                      <textarea class="form-control form-control-solid p-4" rows="2" v-model="q['reference']"></textarea>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div class="mt-5">
                      <label class="fs-5 fw-bolder form-label mb-2">
                        Answer type
                      </label>
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer" label="title" v-model="q['type']"
                        :options="hafezliNewObj.objects.quiz">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div class="invalid-feedback d-none">متن خطا</div>
                    </div>
                    <div v-if="q.type == 'clozeTest'">
                      Put answers in correct order, the system will change the order.
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'blank'">
                      <input v-for="(a, ai) in q['answer']" :key="ai" class="form-control form-control-solid p-4 mt-2"
                        type="text" :placeholder="`Correct answer ${ai + 1}`" v-model="q['answer'][ai]" />
                    </div>
                    <div v-else-if="q.type == 'matching'">
                      <div class="w-100 p-5 border border-1 border-dotted rounded border-gray-500"
                        v-for="(a, ai) in q['answer']" :key="ai">
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Phrase ${ai + 1}`" v-model="q['answer'][ai]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text"
                          :placeholder="`Let it free or fill in answer of ${ai + 1}`" v-model="q['leftAnswer'][ai]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == 'shortAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == 'longAns'">
                      <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                        v-model="q['answer'][0]" />
                    </div>
                    <div v-else-if="q.type == '2choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '3choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                      </div>
                    </div>
                    <div v-else-if="q.type == '4choices'">
                      <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                        class="form-control form-control-solid cursor-pointer mt-2" label="title"
                        v-model="q['answerType']" :options="hafezliNewObj.objects.general">
                        <template v-slot:option="{ option }">
                          {{ option.title }}
                        </template>
                      </multiselect>
                      <div v-if="q['answerType'] && q['answerType'] == 'uploads'">
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quizes',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 0
                          })
                          " class="fv-row">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][0] && q['answer'][0].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][0]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 1
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][1] && q['answer'][1].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][1]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 2
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][2] && q['answer'][2].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][2]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="
                          setModalConfigs('choose', {
                            root: 'files',
                            depth: 2,
                            child: 'tasks',
                            index: hafezliCurStepIndex,
                            subChild: 'quiz',
                            childIndex: ti,
                            subIndex: qi,
                            elIndex: 3
                          })
                          " class="fv-row mt-2">
                          <div class="dropzone bg-light-primary rounded border-primary border border-dashed"
                            id="kt_dropzonejs_example_1">
                            <div v-if="q['answer'][3] && q['answer'][3].length > 1"
                              class="d-flex flex-center flex-wrap scroll-y mh-200px">
                              <div v-for="photo in q['answer'][3]" :key="photo"
                                class="d-flex flex-column flex-center bg-dark bg-opacity-5 rounded border border-dashed border-primary p-5 m-2 col-6">
                                <div class="symbol symbol-100px">
                                  <!-- <img
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${photo}`"
                                /> -->
                                  <img src="/assets/images/png/uploadfilepreview.png" alt="upload.png" />
                                </div>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[0]
                                    : photo["filename"]
                                      ? photo["filename"].split(".")[0]
                                      : "???"
                                }}</label>
                                <label for="">{{
                                  typeof photo == "string"
                                    ? photo.split(".")[1].toUpperCase()
                                    : photo["filename"]
                                      ? photo["filename"]
                                        .split(".")[1]
                                        .toUpperCase()
                                      : "???"
                                }}</label>
                              </div>
                            </div>
                            <div v-else
                              class="dz-message needsclick text-start justify-content-center justify-content-lg-start">
                              <i class="bi bi-file-earmark-arrow-up text-primary fs-3x"></i>
                              <div class="ms-4">
                                <h3 class="fs-5 fw-bolder text-gray-900 mb-1">

                                </h3>
                                <span class="fs-7 fw-bold text-gray-400">Max files to be selected: 10</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Correct answer`"
                          v-model="q['answer'][0]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][1]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][2]" />
                        <input class="form-control form-control-solid p-4 mt-2" type="text" :placeholder="`Wrong answer`"
                          v-model="q['answer'][3]" />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <!-- <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  نوع پاسخ زبان‌آموز را انتخاب نمایید
                </label>
                <multiselect mode="single" :canDeselect="false" :hideSelected="true" :searchable="true"
                  class="form-control form-control-solid cursor-pointer" label="title"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].followUp.ansType"
                  :options="hafezliNewObj.objects.general">
                  <template v-slot:option="{ option }">
                    {{ option.title }}
                  </template>
                </multiselect>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div> -->
            </div>
            <div v-else class="w-100 scroll-y">
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Lesson title
                </label>
                <input class="form-control form-control-solid p-4" type="text"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].title" />
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
              <div class="mt-5">
                <label class="fs-5 fw-bolder form-label mb-2">
                  Lesson summary
                </label>
                <textarea class="form-control form-control-solid p-4" rows="2"
                  v-model="hafezliNewObj.info[hafezliCurStepIndex].summary"></textarea>
                <div class="invalid-feedback d-none">متن خطا</div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 10vh" class="modal-footer d-flex justify-content-center border-gray-500 shadow-lg">
          <button type="submit" class="btn btn-sm btn-success" @click="createHafezliProduct_New">
            Save
          </button>
          <button type="submit" class="btn btn-sm btn-danger" @click="closeModal">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!--end::Modal dialog-->
    <upload-assets v-if="modalDisplay" :contents="null" :modalInfo="uploadInfo" :mode="mode" :modalType="modalType"
      @close-modal="setModalConfigs"></upload-assets>
    <select-template v-if="templateModalDisplay" :contents="null" :modalInfo="templateInfo"
      @close-modal="setModalConfigs"></select-template>
    <select-element v-if="elementsModalDisplay" :contents="null" :modalInfo="elementsModalInfo"
      @close-modal="setModalConfigs"></select-element>
    <config-element v-if="configElementModalDisplay" :contents="null" :modalInfo="elementModalInfo"
      @close-modal="setModalConfigs"></config-element>
    <!--end::Modals-->
    <div>
      <FsLightbox :toggler="toggler" :sources="[`${softBoxSource}`]" />
    </div>
  </div>
</template>

<script>
import UploadAssets from "../modals/UploadAssets.vue";
import SelectTemplate from "../modals/SelectTemplate.vue";
import SelectElement from "../modals/SelectElement.vue";
import ConfigElement from "../modals/ConfigElement.vue";
import Multiselect from "@vueform/multiselect";
import Editor from "@tinymce/tinymce-vue";
import Dropzone from "dropzone";
// import VueDatePicker from '@vuepic/vue-datepicker';
import serverConfigs from "../../configs/server.json";
import dataService from "../../services/data";
import FsLightbox from "fslightbox-vue";
// import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: {
    UploadAssets,
    SelectTemplate,
    SelectElement,
    multiselect: Multiselect,
    editor: Editor,
    FsLightbox,
    ConfigElement,
    // VueDatePicker
  },
  data() {
    return {
      shareType: "",
      hafezliNewObj: {
        curStep: '0',
        curTask: 0,
        steps: [
          {
            title: 'Basic info',
            name: 'basicInfo'
          },
          {
            title: 'Activity',
            name: 'chapterInfo',
            sessions: [
              {
                id: '1',
                title: 'Lead-in (Engage)',
                name: 'lead'
              },
              {
                id: '2',
                title: 'Task (Study)',
                name: 'tasks'
              },
              {
                id: '3',
                title: 'Follow-up (Activate)',
                name: 'followUp'
              }
            ]
          }
        ],
        teachers: [
          {
            value: "1",
            title: "استاد 1"
          }
        ],
        categories: [],
        tags: [],
        info: [
          {
            files: [],
            title: "",
            summary: "",
            description: ""
          },
          {
            lead: {
              lock: true,
              title: "",
              summary: "",
              description: "",
              files: [],
              question: false,
              ansType: "",
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                reference: "",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            },
            tasks: [{
              description: "",
              files: [],
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                reference: "",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            }],
            followUp: {
              description: "",
              files: [],
              ansType: "",
              quizes: [{
                type: "",
                question: "",
                summary: "",
                answerType: "text",
                reference: "",
                answer: ["", "", "", "", "", "", "", "", "", ""],
                leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
              }]
            }
          }
        ],
        objects: {
          quiz: [
            {
              title: "Cloze test",
              value: "clozeTest",
            },
            {
              title: "Fill in the blanks",
              value: "blank",
            },
            // {
            //   title: "Matching",
            //   value: "matching",
            // },
            {
              title: "Short answer",
              value: "shortAns",
            },
            {
              title: "Long answer",
              value: "longAns",
            },
            {
              title: "2-choices",
              value: "2choices",
            },
            {
              title: "3-choices",
              value: "3choices",
            },
            {
              title: "4-choices",
              value: "4choices",
            },
          ],
          general: [
            {
              title: "Upload files (photo, video or voice)",
              value: "upload",
            },
            {
              title: "Text input",
              value: "blank",
            }
          ]
        },
      },
      formInputsConfig: {
        general: [
          {
            name: "label",
            type: "text",
          },
          {
            name: "placeholder",
            type: "text",
          },
          {
            name: "tip",
            type: "summary",
          },
          {
            name: "required",
            type: "toggle",
          },
          {
            name: "conditions",
            type: "multiselect",
            options: [
              {
                label: "Check if the input is empty",
                value: "isEmpty",
              },
              {
                label: "Check if the input is just spaces",
                value: "isSpace",
              },
              {
                label: "Check if the input is just spaces",
                value: "isCorrectAnswer",
              },
              {
                label: "Check if the input is more than min length",
                value: "isMinLength",
              },
              {
                label: "Check if the input lower than max length",
                value: "isMaxLength",
              },
              {
                label: "Check if the input is just spaces",
                value: "isSpace",
              },
            ],
          },
        ],
        text: [
          {
            name: "mode",
            type: "combobox",
            options: [
              {
                label: "A sentence",
                value: "single",
              },
              {
                label: "A paragraph",
                value: "multi",
              },
              {
                label: "Text Editor",
                value: "editor",
              },
            ],
          },
          {
            name: "ui",
            type: "combobox",
            options: [
              {
                label: "Text Box",
                value: "text",
              },
              {
                label: "Textarea",
                value: "textarea",
              },
            ],
          },
          {
            vif: "isMinLength",
            name: "minLength",
            type: "tel",
          },
          {
            vif: "isMaxLength",
            name: "maxLength",
            type: "tel",
          },
        ],
        select: [],
        file: [],
      },
      hafezliWizardStep: "basicInfo",
      hafezliSessionNo: -1,
      hafezliCoursesObj: {
        courseAttachment: [],
        courseTitle: "",
        courseSummary: "",
        coursePrice: 0,
        courseTeacher: null,
        courseTeachers: [
          {
            value: 1,
            title: "استاد 1",
          },
          {
            value: 2,
            title: "استاد 2",
          },
          {
            value: 3,
            title: "استاد 3",
          },
          {
            value: 4,
            title: "استاد 4",
          },
        ],
        courseCategory: null,
        courseCategories: [
          {
            value: 1,
            title: "دسته بندی 1",
          },
          {
            value: 2,
            title: "دسته بندی 2",
          },
          {
            value: 3,
            title: "دسته بندی 3",
          },
          {
            value: 4,
            title: "دسته بندی 4",
          },
        ],
        courseTags: [],
        courseTagsList: [
          {
            value: 1,
            title: "برچسب 1",
          },
          {
            value: 2,
            title: "برچسب 2",
          },
          {
            value: 3,
            title: "برچسب 3",
          },
          {
            value: 4,
            title: "برچسب 4",
          },
        ],
        courseTopics: [
          {
            value: "listening",
            title: "شنیدار",
          },
          {
            value: "speaking",
            title: "مکالمه",
          },
          {
            value: "Writing",
            title: "نوشتار",
          },
          {
            value: "reading",
            title: "درک مطلب",
          },
        ],
        courseDescription: "",
        courseLeadObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
        ],
        courseTaskObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
          {
            title: "writing",
            value: "writing",
          },
          {
            title: "reading",
            value: "reading",
          },
          {
            title: "conversation",
            value: "conversation",
          },
        ],
        courseQuizObjOptions: [
          {
            title: "audio",
            value: "audio",
          },
          {
            title: "video",
            value: "video",
          },
          {
            title: "image",
            value: "image",
          },
          {
            title: "table",
            value: "table",
          },
          {
            title: "text",
            value: "text",
          },
        ],
        courseQuizAnsOptions: [
          {
            title: "blank",
            value: "blank",
          },
          {
            title: "clozeTest",
            value: "clozeTest",
          },
          {
            title: "4choices",
            value: "4choices",
          },
          {
            title: "3choices",
            value: "3choices",
          },
          {
            title: "2choices",
            value: "2choices",
          },
          {
            title: "shortAns",
            value: "shortAns",
          },
          {
            title: "longAns",
            value: "longAns",
          },
          {
            title: "matching",
            value: "matching",
          },
        ],
        courseFollowupOptions: [
          {
            title: "upload",
            value: "upload",
          },
          {
            title: "blank",
            value: "blank",
          },
          {
            title: "table",
            value: "table",
          },
        ],
        courseQuizAnsObj: {
          question: "",
          type: "",
          ans: "",
          options: ["", "", "", "", "", "", "", "", "", ""],
          matchingOptions: [
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
            {
              text: "",
              ans: "",
            },
          ],
        },
        courseQuizAnsTypes: [
          {
            title: "Image",
            value: "image",
          },
          {
            title: "Text",
            value: "text",
          },
        ],
        courseSessions: [],
        courseQuizForms: [],
      },
      hafezliSessionsObj: {
        sessionLock: "",
        sessionFramework: {
          lead: {
            summary: "",
            objType: "",
            form: 0,
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
            },
            ansStatus: true,
            userAns: "",
          },
          task: {
            summary: "",
            objType: "",
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
              text: "",
            },
            quiz: {
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              forms: [],
              form: 0,
            },
          },
          followup: {
            summary: "",
            objType: "",
            obj: {
              headers: ["", "", "", "", ""],
              records: {
                row1: ["", "", "", "", ""],
                row2: ["", "", "", "", ""],
                row3: ["", "", "", "", ""],
                row4: ["", "", "", "", ""],
                row5: ["", "", "", "", ""],
              },
              file: [],
              text: "",
            },
            ansType: "",
            form: 0,
            userAns: "",
          },
        },
      },
      temptime: null,
      vidisciObj: {
        step: 0,
        steps: [
          {
            name: "step0",
            title: "Choose template",
          },
          {
            name: "step1",
            title: "Create / Edit video",
          },
          {
            name: "step2",
            title: "Theme color",
          },
          {
            name: "step3",
            title: "Music / Soundtrack",
          },
          {
            name: "step4",
            title: "Preview & Render",
          }
        ],
        videoInfo: {}
      },
      tinyMCE_Def: {
        menubar: true,
        plugins: "lists link emoticons directionality",
        toolbar:
          "styleselect | bold italic | alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist | link emoticons",
        directionality: '',
        minHeight: 600,
      },
      inlineConfigDisplay: false,
      softBoxSource: "",
      focusStatus: false,
      pac: true,
      infoImage: {},
      infoElement: {},
      displayStatus: false,
      value: null,
      uploadInfo: {
        images: [],
        current: {},
      },
      groupItems: [],
      toggler: false,
      elementsModalInfo: {},
      elementModalInfo: {},
      elementsModalDisplay: false,
      configElementModalDisplay: false,
      modalDisplay: false,
      templateInfo: {},
      templateModalDisplay: false,
      dropzoneCounter: 0,
      info: {},
      verifyCode: "",
      verifyCodeErrorClass: "",
      verifyTime: true,
      countDown: 5,
      generalStep: 1,
      templateOption: {
        status: false
      }
    };
  },
  props: {
    routeLocale: {
      require: false,
    },
    stepType: {
      require: false,
    },
    contents: {
      required: true,
    },
    modalInfo: {
      required: false,
    },
    mode: {},
    modalType: {
      required: true,
    },
    enableTimer: {
      required: false,
    },
    firstErrorName: {
      required: false,
    },
    icons: {
      required: false,
    },
  },
  computed: {
    editorDirection() {
      if (['fa', 'ar'].indexOf(this.$route.params.locale) > -1) {
        return 'rtl'
      }
      return 'ltr'
    },
    routeFullPath() {
      return this.$route.fullPath.includes("myproducts");
    },
    hafezliCurStepIndex() {
      return this.hafezliNewObj.curStep.split('-')[0]
    },
    tinymceToken() {
      return serverConfigs["tinymceToken"];
    },
    inlineRouteLocale() {
      return this.$route.params.locale;
    },
    templateIndex() {
      let index = "";
      for (let b in this.contents.fields[0].options) {
        if (
          this.contents.fields[0].options[b].value == this.info["blogTemplate"]
        ) {
          index = b;
        }
      }
      console.log(index)
      return index;
    },
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    modalOverlay() {
      let elem = document.createElement("div");
      elem.style.cssText = "z-index:109";
      elem.classList.add("drawer-overlay");
      return elem;
    },
    modalNode() {
      return document.getElementsByClassName("modal fade")[0];
    },
    bodyNode() {
      return document.getElementById("kt_body");
    },
  },
  methods: {
    collapseHafezliTask_New(index) {
      this.hafezliNewObj.curTask = index
    },
    changeHafezliStep_New(index) {
      this.hafezliNewObj.curStep = index;
      this.hafezliNewObj.curTask = 0;
    },
    changeHafezliTask_New(index) {
      this.hafezliNewObj.curTask = index;
    },
    addHafezliSteps_New(index) {
      this.hafezliNewObj.steps.splice(index + 1, 0, {
        title: 'Activity',
        name: 'chapterInfo',
        sessions: [
          {
            id: '1',
            title: 'Lead-in (Engage)',
            name: 'lead'
          },
          {
            id: '2',
            title: 'Task (Study)',
            name: 'tasks'
          },
          {
            id: '3',
            title: 'Follow-up (Activate)',
            name: 'followUp'
          }
        ]
      })
      this.hafezliNewObj.info.splice(index + 1, 0, {
        lead: {
          lock: true,
          title: "",
          summary: "",
          description: "",
          files: [],
          question: false,
          ansType: "",
        },
        tasks: [{
          description: "",
          files: [],
          quizes: [{
            type: "",
            question: "",
            summary: "",
            answerType: "text",
            answer: ["", "", "", "", "", "", "", "", "", ""],
            leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
          }]
        }],
        followUp: {
          description: "",
          files: [],
          ansType: "",
        }
      })
      console.log(this.hafezliNewObj.steps)
      console.log("Add step")
    },
    deleteHafezliSteps_New(index) {
      this.hafezliNewObj.curStep = '0';
      this.hafezliNewObj.steps.splice(index, 1)
      this.hafezliNewObj.info.splice(index, 1)
      console.log(this.hafezliNewObj.steps)
      console.log("Delete step")
    },
    addHafezliTask_New(index) {
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks.splice(index + 1, 0, {
        description: "",
        files: [],
        quizes: [{
          type: "",
          question: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        }]
      })
      console.log(this.hafezliNewObj.steps)
      console.log("Add task")
    },
    deleteHafezliTask_New(index) {
      this.hafezliNewObj.curTask = 0
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks.splice(index, 1)
      console.log("Delete task")
    },
    addHafezliQuiz_New(taskIndex, index) {
      if (taskIndex == 'lead' || taskIndex == 'followUp') {
        this.hafezliNewObj.info[this.hafezliCurStepIndex][taskIndex].quizes.splice(index + 1, 0, {
          type: "",
          question: "",
          summary: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        })
      } else {
        this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks[taskIndex].quizes.splice(index + 1, 0, {
          type: "",
          question: "",
          summary: "",
          answerType: "text",
          answer: ["", "", "", "", "", "", "", "", "", ""],
          leftAnswer: ["", "", "", "", "", "", "", "", "", ""]
        })
      }
      console.log("Add quiz")
    },
    deleteHafezliQuiz_New(taskIndex, index) {
      this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks[taskIndex].quizes.splice(index, 1)
      console.log("Delete quiz")
    },
    createHafezliProduct_New() {
      if (this.modalInfo[0] && this.modalInfo[0].id) {
        this.hafezliNewObj.info[0]["id"] = this.modalInfo[0].id;
      }
      this.closeModal("hliLessonsValidate", this.hafezliNewObj.info);
      // this.hafezliNewObj.info = [
      //   {
      //     "files": [
      //       "1751222151600_SaminLogo.png"
      //     ],
      //     "title": "Test Package",
      //     "summary": "It's a test package",
      //     "price": 1500000,
      //     "teacher": "1",
      //     "category": 663,
      //     "tags": [
      //       130,
      //       188
      //     ],
      //     "description": "<p>Test 1 2 3 4</p>"
      //   },
      //   {
      //     "lead": {
      //       "lock": true,
      //       "title": "Chapter 1",
      //       "summary": "It's chapter 1 about PPT",
      //       "description": "",
      //       "files": [
      //         "1746889882047_English_Conversation_at_a_Cafe_Coffee_Shop_Useful_Phrases.mp4"
      //       ],
      //       "question": true,
      //       "ansType": "blank"
      //     },
      //     "tasks": [
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "2choices",
      //             "question": "",
      //             "summary": "It's a tip for quiz",
      //             "answerType": "blank",
      //             "answer": [
      //               "123",
      //               "456",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           },
      //           {
      //             "type": "clozeTest",
      //             "question": "",
      //             "summary": "It's a tip for you",
      //             "answerType": "text",
      //             "answer": [
      //               "1san",
      //               "w",
      //               "s",
      //               "a",
      //               "a",
      //               "a",
      //               "d",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           }
      //         ]
      //       },
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "longAns",
      //             "question": "",
      //             "answerType": "text",
      //             "answer": [
      //               "asdsdasdsad2312321",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ],
      //             "summary": "dsdsadsa2"
      //           }
      //         ]
      //       }
      //     ],
      //     "followUp": {
      //       "description": "",
      //       "files": [
      //         "1746525518325_“23SecretsBaristasatSmallCoffeeShopsWon’t….jpg"
      //       ],
      //       "ansType": "blank"
      //     }
      //   },
      //   {
      //     "lead": {
      //       "lock": true,
      //       "title": "Chapter 2",
      //       "summary": "Chapter 2 summary",
      //       "description": "",
      //       "files": [
      //         "1744790273661_controlpractice.mp4"
      //       ],
      //       "question": false,
      //       "ansType": ""
      //     },
      //     "tasks": [
      //       {
      //         "description": "",
      //         "files": [],
      //         "quizes": [
      //           {
      //             "type": "matching",
      //             "question": "",
      //             "summary": "Talk abot it",
      //             "answerType": "text",
      //             "answer": [
      //               "w",
      //               "e",
      //               "4",
      //               "3",
      //               "a",
      //               "4",
      //               "d",
      //               "d",
      //               "d",
      //               ""
      //             ],
      //             "leftAnswer": [
      //               "12",
      //               "asdasd",
      //               "dsfdfd",
      //               "asdsa",
      //               "",
      //               "",
      //               "",
      //               "",
      //               "",
      //               ""
      //             ]
      //           }
      //         ]
      //       }
      //     ],
      //     "followUp": {
      //       "description": "",
      //       "files": [
      //         "1751222151600_SaminLogo.png"
      //       ],
      //       "ansType": "upload"
      //     }
      //   }
      // ]
    },
    hafezliCreateObj() {
      if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "matching"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = [{ q: "", a: "" }];
      } else if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "4choices"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = ["", "", ""];
      } else if (
        this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo]
          .sessionAnswerType == "truefalse"
      ) {
        this.hafezliCoursesObj.courseSessions[
          this.hafezliSessionNo
        ].sessionChoices = [""];
      }
    },
    handleBtnClick(opt, arrObj, index) {
      if (opt == "add") {
        arrObj.push(index);
      } else {
        arrObj.splice(index, 1);
      }
    },
    setVidisciStep(index) {
      this.vidisciObj.step = index;
    },
    showSessions() {
      // this.hafezliCoursesObj = {
      //   courseAttachment: [],
      //   courseTitle: "دوره ۱",
      //   courseSummary: "خلاصه دوره ۱",
      //   coursePrice: 0,
      //   courseTeacher: 1,
      //   courseTeachers: [
      //     {
      //       value: 1,
      //       title: "استاد 1",
      //     },
      //     {
      //       value: 2,
      //       title: "استاد 2",
      //     },
      //     {
      //       value: 3,
      //       title: "استاد 3",
      //     },
      //     {
      //       value: 4,
      //       title: "استاد 4",
      //     },
      //   ],
      //   courseCategory: 1,
      //   courseCategories: [
      //     {
      //       value: 1,
      //       title: "دسته بندی 1",
      //     },
      //     {
      //       value: 2,
      //       title: "دسته بندی 2",
      //     },
      //     {
      //       value: 3,
      //       title: "دسته بندی 3",
      //     },
      //     {
      //       value: 4,
      //       title: "دسته بندی 4",
      //     },
      //   ],
      //   courseTags: [1, 2],
      //   courseTagsList: [
      //     {
      //       value: 1,
      //       title: "برچسب 1",
      //     },
      //     {
      //       value: 2,
      //       title: "برچسب 2",
      //     },
      //     {
      //       value: 3,
      //       title: "برچسب 3",
      //     },
      //     {
      //       value: 4,
      //       title: "برچسب 4",
      //     },
      //   ],
      //   courseTopics: [
      //     {
      //       value: "listening",
      //       title: "شنیدار",
      //     },
      //     {
      //       value: "speaking",
      //       title: "مکالمه",
      //     },
      //     {
      //       value: "Writing",
      //       title: "نوشتار",
      //     },
      //     {
      //       value: "reading",
      //       title: "درک مطلب",
      //     },
      //   ],
      //   courseAnswerTypes: [
      //     {
      //       value: "4choices",
      //       title: "4 گزینه‌ای",
      //     },
      //     {
      //       value: "truefalse",
      //       title: "درست / نادرست",
      //     },
      //     {
      //       value: "short",
      //       title: "پاسخ کوتاه",
      //     },
      //     {
      //       value: "long",
      //       title: "تشریحی",
      //     },
      //   ],
      //   courseDescription: "",
      //   courseSessions: [
      //     {
      //       sessionLock: "",
      //       sessionType: "teaching",
      //       sessionTopic: "",
      //       sessionTitle: "جلسه ۱",
      //       sessionSummary: "خلاصه جلسه ۱",
      //       sessionPassPoint: "",
      //       sessionDuration: "",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionDescription: "",
      //     },
      //     {
      //       sessionLock: "",
      //       sessionType: "quiz",
      //       sessionTopic: "listening",
      //       sessionTitle: "کوییز ۱",
      //       sessionSummary: "سوال کوییز ۱",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionChoices: ["نادرست"],
      //       sessionAnswerType: "truefalse",
      //       sessionPassPoint: 10,
      //       sessionDuration: 45,
      //       sessionDescription: "توضیحات و نکات کوییز ۱",
      //     },
      //     {
      //       sessionLock: "",
      //       sessionType: "homework",
      //       sessionTopic: "",
      //       sessionTitle: "تمرین ۱",
      //       sessionSummary: "متن تمرین ۱",
      //       sessionPassPoint: "",
      //       courseAnswerType: "",
      //       sessionAnswer: "",
      //       sessionDuration: 1,
      //       sessionDescription: "پاسخ خود را آ\\لود کنید",
      //     },
      //   ],
      // };
      if (this.modalInfo.id) {
        this.hafezliCoursesObj["id"] = this.modalInfo.id;
      }
      // console.log(this.hafezliCoursesObj)
      this.closeModal("validate", this.hafezliCoursesObj);
    },
    setSessionType(type) {
      this.hafezliWizardStep = "sessionInfo";
      this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
        "sessionType"
      ] = type;
    },
    nextSession() {
      this.hafezliSessionNo += 1;
      this.hafezliWizardStep = "lead";
    },
    addGroupItem(event, item, index) {
      if (event.target.checked) {
        this.groupItems.push({ ...item, index: index });
      } else {
        this.groupItems.splice(
          this.groupItems.indexOf({ ...item, index: index }),
          1
        );
      }
      console.log(this.groupItems);
    },
    groupingItems() {
      let cardFields = [];
      let cardDefault = {};
      let cardJson = {
        name: "cardItems",
        title: "Group Items",
        type: "card",
        required: false,
        default: {},
        value: {},
        count: 1,
        fields: [],
        editable: true,
        sortable: true,
        searchable: true,
        filterable: true,
        showable: true,
      };

      for (let i in this.groupItems) {
        cardFields.push(
          this.info["sectionJson"]["fields"][this.groupItems[i]["index"] - i]
        );
        cardDefault[this.groupItems[i]["name"]] =
          this.info["sectionJson"]["fields"][this.groupItems[i]["index"] - i][
          "default"
          ];
        this.info["sectionJson"]["fields"].splice(
          this.groupItems[i]["index"] - i,
          1
        );
        delete this.info["sectionJson"]["default"][this.groupItems[i]["name"]];

        this.info["sectionElements"][this.groupItems[i]["index"]][
          "grouped"
        ] = true;
        this.info["sectionElements"][this.groupItems[i]["index"]]["groupName"] =
          cardJson["name"];
      }

      cardJson.fields = cardFields;
      cardJson.default = [cardDefault];
      console.log(cardJson);

      this.info["sectionJson"]["fields"].push(cardJson);
      this.info["sectionJson"]["default"][cardJson["name"]] = [cardDefault];
    },
    async mergeElementJson(el, elName) {
      let tempEl = {};
      Object.assign(tempEl, {
        id: el["id"],
        name: elName,
        json: el["elementJson"],
        properties: el["elementProperties"],
      });

      let tempJson = {};
      for (let j in tempEl["json"]) {
        tempJson[j] = tempEl["json"][j]["value"];

        if (j == "name") {
          tempJson["name"] = tempEl["name"];
        }
      }

      for (let j in tempEl["properties"]) {
        tempJson[j] = tempEl["properties"][j]["value"];
      }

      return tempJson;
    },
    previousSession() {
      this.hafezliSessionNo -= 1;
      this.hafezliWizardStep = "sessionInfo";
    },
    addNewSession() {
      if (
        this.hafezliSessionNo ==
        this.hafezliCoursesObj.courseSessions.length - 1
      ) {
        let tempSessionObj = {};
        // Object.assign(tempSessionObj, this.hafezliSessionsObj);
        Object.assign(tempSessionObj, {
          sessionLock: "",
          sessionFramework: {
            lead: {
              summary: "",
              objType: "",
              form: 0,
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
              },
              ansStatus: true,
              userAns: "",
            },
            task: {
              summary: "",
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              quiz: {
                objType: "",
                obj: {
                  headers: ["", "", "", "", ""],
                  records: {
                    row1: ["", "", "", "", ""],
                    row2: ["", "", "", "", ""],
                    row3: ["", "", "", "", ""],
                    row4: ["", "", "", "", ""],
                    row5: ["", "", "", "", ""],
                  },
                  file: [],
                  text: "",
                },
                forms: [],
                form: 0,
              },
            },
            followup: {
              summary: "",
              objType: "",
              obj: {
                headers: ["", "", "", "", ""],
                records: {
                  row1: ["", "", "", "", ""],
                  row2: ["", "", "", "", ""],
                  row3: ["", "", "", "", ""],
                  row4: ["", "", "", "", ""],
                  row5: ["", "", "", "", ""],
                },
                file: [],
                text: "",
              },
              ansType: "",
              form: 0,
              userAns: "",
            },
          },
        });
        this.hafezliCoursesObj.courseSessions.push(tempSessionObj);
      }

      this.hafezliSessionNo += 1;
      this.hafezliWizardStep = "lead";
    },
    nextPart() {
      if (this.hafezliWizardStep == "lead") {
        this.hafezliWizardStep = "task";
      } else if (this.hafezliWizardStep == "task") {
        this.hafezliWizardStep = "followup";
      }
    },
    previousPart() {
      if (this.hafezliWizardStep == "task") {
        this.hafezliWizardStep = "lead";
      } else if (this.hafezliWizardStep == "followup") {
        this.hafezliWizardStep = "task";
      }
    },
    hafezliBlankQuizSymbole(question) {
      let tempLen = question.length;
      if (tempLen > 3) {
        if (question[tempLen - 3] == "_" && question[tempLen - 1] == "_") {
          this.hafezliAddQuiz();
        }
      }
    },
    hafezliAddQuiz() {
      let tempQuziAnsObj = {};
      Object.assign(tempQuziAnsObj, {
        question: "",
        type: "",
        ans: "",
        ansType: "",
        options: ["", "", "", "", "", "", "", "", "", ""],
        matchingOptions: [
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
          {
            text: "",
            ans: "",
          },
        ],
        userAns: "",
      });
      console.log(tempQuziAnsObj);
      this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
        "sessionFramework"
      ][this.hafezliWizardStep]["quiz"]["forms"].push(tempQuziAnsObj);
    },
    deleteSession() {
      this.hafezliCoursesObj.courseSessions.splice(this.hafezliSessionNo, 1);
      if (this.hafezliSessionNo == 0) {
        this.hafezliWizardStep = "basicInfo";
      }
      this.hafezliSessionNo -= 1;
    },
    editPreviousSession() {
      this.hafezliSessionNo -= 1;

      this.hafezliWizardStep =
        this.hafezliSessionNo == -1 ? "basicInfo" : "chooseSessionType";
    },
    fetchIcons(query) {
      if (query) {
        return this.icons.filter((icon) => icon.title.includes(query));
      }

      return this.icons;
    },
    changeOrder(array, index, direction) {
      let temp = "";
      switch (direction) {
        case "up":
          temp = array[index];
          array[index] = array[index - 1];
          array[index - 1] = temp;
          break;
        case "down":
          temp = array[index];
          array[index] = array[index + 1];
          array[index + 1] = temp;
          break;
        default:
          break;
      }
    },
    chooseRow(event, root, value) {
      for (let item in this.info[root][value.name]) {
        this.info[root][value.name][item] = event.target.checked;
      }
    },
    addChild(root, index, key, child, rootIndex) {
      if (rootIndex) {
        let temp = {};
        for (let field in rootIndex.fields) {
          if (rootIndex.fields[field].type == "card") {
            let t = {};
            Object.assign(
              t,
              rootIndex.fields[field].value ? rootIndex.fields[field].value : ""
            );
            temp[rootIndex.fields[field].name] = [t];
          } else {
            temp[rootIndex.fields[field].name] = rootIndex.fields[field].value;
          }
        }

        if (temp) {
          this.info[root].push(temp);
        }
      } else {
        let temp = {};
        if (key) {
          Object.assign(temp, child);
          this.info[root][index][key].push(temp);
        } else {
          let tempRoot = {};
          for (let i in this.contents.fields[6].fields) {
            switch (this.contents.fields[6].fields[i].type) {
              case "text":
                tempRoot[this.contents.fields[6].fields[i].name] = "";
                break;
              case "textarea":
                tempRoot[this.contents.fields[6].fields[i].name] = "";
                break;
              case "card":
                Object.assign(temp, child);

                tempRoot[this.contents.fields[6].fields[i].name] = [temp];
                break;
              default:
                break;
            }
          }
          this.info[root].push(tempRoot);
        }
      }
    },
    delChild(root, index, key) {
      key ? this.info[root][index][key].pop() : this.info[root].pop();
      // if (this.$route.path.includes("contents")) {
      //   key
      //     ? this.info[root][index][key].pop()
      //     : this.info[root].splice(index - 3, 1);
      // } else {
      //   key ? this.info[root][index][key].pop() : this.info[root].pop();
      // }
    },
    addComponentChild(obj, child) {
      let temp = {};
      Object.assign(temp, child);
      obj.push(temp);
    },
    delComponentChild(obj, index) {
      obj.splice(index);
      // if (this.$route.path.includes("contents")) {
      //   key
      //     ? this.info[root][index][key].pop()
      //     : this.info[root].splice(index - 3, 1);
      // } else {
      //   key ? this.info[root][index][key].pop() : this.info[root].pop();
      // }
    },
    setOfset(field) {
      let modalEl = document.getElementById("kt_modal_add_role_scroll");
      modalEl.scroll(0, 20 * field.options.length);
      modalEl.style.overflow = "hidden";
    },
    inlineEditConfigs(el) {
      el["editMode"] = !el["editMode"];
    },
    setModalConfigs(opt, index) {
      switch (opt) {
        case "elementSettings":
          this.elementModalInfo = {
            ...this.info["sectionElements"][index],
            index: index,
          };
          this.configElementModalDisplay = true;
          break;
        case "elementSetting": {
          let tempJson1 = {};
          for (let j in index["json"]) {
            tempJson1[j] = index["json"][j]["value"];
          }

          for (let j in index["properties"]) {
            tempJson1[j] = index["properties"][j]["value"];
          }

          if (index["grouped"]) {
            console.log("Here");
          } else {
            this.info["sectionJson"]["fields"][index["index"]] = tempJson1;

            let defKeys1 = Object.keys(this.info["sectionJson"]["default"]);
            this.info["sectionJson"]["default"][defKeys1[index["index"]]] =
              tempJson1["default"];
          }

          this.configElementModalDisplay = false;
          break;
        }
        case "element":
          this.elementsModalDisplay = false;
          if (index["status"] == "create") {
            let defKeys = Object.keys(this.info["sectionJson"]["default"]);
            let elName = `${index["element"]["elementName"]}_1`;

            if (defKeys.length > 0 && defKeys.indexOf(elName) > -1) {
              let elNamePre = index["element"]["elementName"];
              let elIndex = 0;
              for (let i in defKeys) {
                if (String(defKeys[i]).includes(elNamePre)) {
                  elIndex = i;
                }
              }

              let elNameTemp = String(defKeys[elIndex]).split("_");
              elNameTemp = Number(elNameTemp[elNameTemp.length - 1]) + 1;
              elName = `${index["element"]["elementName"]}_${String(
                elNameTemp
              )}`;
            }
            index["element"]["elementProperties"];

            let tempEl = {};
            Object.assign(tempEl, {
              id: index["element"].id,
              // name: index['element']['elementName'],
              name: elName,
              json: index["element"]["elementJson"],
              properties: index["element"]["elementProperties"],
            });

            let tempJson = {};
            for (let j in tempEl["json"]) {
              tempJson[j] = tempEl["json"][j]["value"];

              if (j == "name") {
                tempJson["name"] = tempEl["name"];
              }
            }

            for (let j in tempEl["properties"]) {
              tempJson[j] = tempEl["properties"][j]["value"];
            }

            this.info["sectionElements"].push(tempEl);
            this.info["sectionJson"]["fields"].push(tempJson);
            this.info["sectionJson"]["default"][`${tempEl["name"]}`] =
              tempJson["default"];
          }
          console.log(this.info);
          break;
        case "elements":
          this.readElements(index);
          break;
        case "templates":
          this.templateInfo = {
            value: this.info[index.value] ? this.info[index.value] : "",
            category: index.category,
            field: index.value,
          };
          this.templateModalDisplay = !this.templateModalDisplay;
          break;
        case "template":
          this.templateInfo = {};
          this.info[index.field] = index.template;
          this.templateModalDisplay = !this.templateModalDisplay;
          break;
        case "choose":
          this.infoImage = index;

          this.getUploads();
          break;
        case "select":
          this.info.templateJson.fields[0].value = index;
          this.modalDisplay = !this.modalDisplay;
          break;
        case "update":
          this.roleInfo = { ...this.roles[index], status: true };
          this.roleInfo.rolePermissions = JSON.parse(
            this.roleInfo.rolePermissions
          );
          this.modalDisplay = !this.modalDisplay;
          break;
        case "create":
          this.setupRoleInfo();
          this.modalDisplay = !this.modalDisplay;
          break;
        case "validate":
          if (this.inputValidation(index)) {
            index.id ? this.updateRoles(index) : this.createRoles(index);
          }
          break;
        case "photo":          
          if (this.hafezliCurStepIndex > 0) {
            console.log(this.hafezliNewObj.curStep)
            if (this.hafezliNewObj.curStep.includes('lead')) {
              this.hafezliNewObj.info[this.hafezliCurStepIndex].lead.files = index.image
            }

            if (this.hafezliNewObj.curStep.includes('tasks')) {
              this.hafezliNewObj.info[this.hafezliCurStepIndex].tasks[this.hafezliNewObj.curTask].files = index.image
            }

            if (this.hafezliNewObj.curStep.includes('followUp')) {
              this.hafezliNewObj.info[this.hafezliCurStepIndex].followUp.files = index.image
            }

            this.modalDisplay = !this.modalDisplay;
          }
          else if (this.stepType == "wizard") {
            if (this.infoImage.depth == 0) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.root] = index.image;
            } else if (this.infoImage.depth == 1) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.child][this.infoImage.root] = index.image;
            } else if (this.infoImage.depth == 2) {
              this.hafezliNewObj.info[this.infoImage.index][this.infoImage.child][this.infoImage.childIndex][this.infoImage.root] = index.image;
            }
            console.log(this.hafezliNewObj.info)
            // if (this.infoImage.subIndex && this.infoImage.subIndex == "forms") {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["quiz"]["forms"][this.infoImage.depth][
            //     "options"
            //   ][this.infoImage.subDepth] = index.image;
            // } else if (this.infoImage.depth == 0) {
            //   this.hafezliCoursesObj[this.infoImage.root] = index.image;
            // } else if (this.infoImage.name == "quiz") {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["quiz"]["obj"]["file"] = index.image;
            // } else {
            //   this.hafezliCoursesObj.courseSessions[this.hafezliSessionNo][
            //     "sessionFramework"
            //   ][this.hafezliWizardStep]["obj"]["file"] = index.image;
            //   // this.hafezliCoursesObj[this.infoImage.root][this.infoImage.index][
            //   //   this.infoImage.name] = index.image;
            // }
            this.modalDisplay = !this.modalDisplay;
          } else {
            if (
              this.infoImage &&
              this.infoImage.depth &&
              this.infoImage.depth == 5
            ) {
              this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
              ][this.infoImage["childIndex"]][this.infoImage["grandchild"]] =
                index.image;
            } else if (
              this.infoImage &&
              this.infoImage.depth &&
              this.infoImage.depth == 3
            ) {
              this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
              ] = index.image[0];
              console.log(
                this.info[this.infoImage["root"]][this.infoImage["index"]][
                this.infoImage["child"]
                ]
              );
            } else if (this.infoImage) {
              this.info[this.infoImage["root"]] = index.image;
              this.info["photos"] = index.image;
            } else {
              this.info["photos"] = index.image;
            }
            this.modalDisplay = !this.modalDisplay;
            if (this.contents.title == "Uploads" && this.modalInfo.status) {
              this.closeModal();
            }
          }
          break;
        default:
          this.modalDisplay = false;
          this.elementsModalDisplay = false;
          this.configElementModalDisplay = false;
          this.templateModalDisplay = false;
          if (this.contents.title == "Uploads" && this.modalInfo.status) {
            this.closeModal();
          }
          break;
      }
    },
    closeModal(opt, index) {
      this.focusStatus = false;
      this.$emit(
        "close-modal",
        opt && opt.length > 0 ? opt : null,
        index ? index : null,
        document.getElementById("dropzoneFiles") &&
          document.getElementById("dropzoneFiles").value &&
          document.getElementById("dropzoneFiles").value.length > 0
          ? document.getElementById("dropzoneFiles").value
          : null
      );
      if (
        document.getElementById("dropzoneFiles") &&
        document.getElementById("dropzoneFiles").value &&
        document.getElementById("dropzoneFiles").value.length > 0
      ) {
        document.getElementById("dropzoneFiles").value = "";
        const id = "#kt_dropzonejs_example_2";
        const dropzone = document.querySelector(id);
        dropzone.querySelector(".dropzone-remove-all").click();
      }
    },
    dropzoneInput() {
      // set the dropzone container id
      const id = "#kt_dropzonejs_example_2";
      const dropzone = document.querySelector(id);

      if (dropzone) {
        // set the preview element template
        var previewNode = dropzone.querySelector(".dropzone-item");
        previewNode.id = "";
        var previewTemplate = previewNode.parentNode.innerHTML;
        previewNode.parentNode.removeChild(previewNode);

        var myDropzone = new Dropzone(id, {
          // Make the whole body a dropzone
          url: `${serverConfigs["serverDomain"]["host"]}/api/v1/uploads/upload?locale=en`, // Set the url for your upload script location
          parallelUploads: 20,
          previewTemplate: previewTemplate,
          maxFilesize: 1000, // Max filesize in MB
          autoQueue: false, // Make sure the files aren't queued until manually added
          previewsContainer: id + " .dropzone-items", // Define the container to display the previews
          clickable: id + " .dropzone-select", // Define the element that should be used as click trigger to select files.
          acceptedFiles: "image/*",
          capture: "camera",
        });

        if (
          "mediaDevices" in navigator &&
          "getUserMedia" in navigator.mediaDevices
        ) {
          console.log("Let's get this party started");
        }

        myDropzone.on("addedfile", function (file) {
          // document
          //   .getElementById("photoPreview")
          //   .setAttribute("src", file.dataURL);
          // Hookup the start button
          file.previewElement.querySelector(
            id + " .dropzone-start"
          ).style.display = "none";

          const dropzoneItems = dropzone.querySelectorAll(".dropzone-item");
          dropzoneItems.forEach((dropzoneItem) => {
            dropzoneItem.style.display = "";
          });
          dropzone.querySelector(".dropzone-upload").style.display =
            "inline-block";
          dropzone.querySelector(".dropzone-remove-all").style.display =
            "inline-block";
          dropzone.querySelector(".dropzone-photo-delete").style.display =
            "none";
        });

        myDropzone.on("thumbnail", function (file, dataURL) {
          document.getElementById("photoPreview").setAttribute("src", dataURL);
        });
        // Update the total progress bar
        myDropzone.on("totaluploadprogress", function (progress) {
          const progressBars = dropzone.querySelectorAll(".progress-bar");
          progressBars.forEach((progressBar) => {
            progressBar.style.width = progress + "%";
          });
        });

        myDropzone.on("sending", function (file) {
          // Show the total progress bar when upload starts
          const progressBars = dropzone.querySelectorAll(".progress-bar");
          progressBars.forEach((progressBar) => {
            progressBar.style.opacity = "1";
          });
          // And disable the start button
          file.previewElement
            .querySelector(id + " .dropzone-start")
            .setAttribute("disabled", "disabled");
        });

        myDropzone.on("success", function (file) {
          let temp =
            document.getElementById("dropzoneFiles").value.length > 0
              ? JSON.parse(document.getElementById("dropzoneFiles").value)
              : [];
          temp.push(JSON.parse(file.xhr.response)[0].filename);
          document.getElementById("dropzoneFiles").value = JSON.stringify(temp);
        });

        // Hide the total progress bar when nothing's uploading anymore
        myDropzone.on("complete", function () {
          const progressBars = dropzone.querySelectorAll(".dz-complete");

          setTimeout(function () {
            progressBars.forEach((progressBar) => {
              progressBar.querySelector(".progress-bar").style.display = "none";
              progressBar.querySelector(".progress").style.display = "none";
              progressBar.querySelector(".dropzone-start").style.display =
                "none";
            });
          }, 300);
        });

        // Setup the buttons for all transfers
        dropzone
          .querySelector(".dropzone-upload")
          .addEventListener("click", function () {
            myDropzone.enqueueFiles(
              myDropzone.getFilesWithStatus(Dropzone.ADDED)
            );
          });

        // Setup the button for remove all files
        dropzone
          .querySelector(".dropzone-remove-all")
          .addEventListener("click", function () {
            dropzone.querySelector(".dropzone-upload").style.display = "none";
            dropzone.querySelector(".dropzone-remove-all").style.display =
              "none";
            dropzone.querySelector(".dropzone-photo-delete").style.display =
              "inline-block";
            myDropzone.removeAllFiles(true);
          });

        // On all files completed upload
        myDropzone.on("queuecomplete", function () {
          const uploadIcons = dropzone.querySelectorAll(".dropzone-upload");
          uploadIcons.forEach((uploadIcon) => {
            uploadIcon.style.display = "none";
          });
          dropzone.querySelector(".dropzone-photo-delete").style.display =
            "inline-block";
        });

        // On all files removed
        myDropzone.on("removedfile", function () {
          if (myDropzone.files.length < 1) {
            dropzone.querySelector(".dropzone-upload").style.display = "none";
            dropzone.querySelector(".dropzone-remove-all").style.display =
              "none";
            dropzone.querySelector(".dropzone-photo-delete").style.display =
              "inline-block";
          }
        });
      }
    },
    readElements(element) {
      let data = {
        endPoint: `elements`,
        pageNo: "",
        locale: `fa`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          let elements = res.data.data;
          for (let i in elements) {
            elements[i].elementDate = new Date(
              elements[i].elementDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            elements[i].elementPhotos = elements[i].elementPhotos.split(",");
          }
          this.elementsModalInfo = {
            elements: elements,
            element: element,
            value: element.id,
            status: element.id == 0 ? "create" : "update",
          };
          this.elementsModalDisplay = true;
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        });
    },
    getUploads() {
      let data = {
        endPoint: `uploads`,
        locale: "fa",
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        // query: {
        //   type: "blog",
        // },
      };
      // data.query = JSON.stringify(data.query)
      //   .replace("{", "")
      //   .replace(",", "&")
      //   .replace("}", "")
      //   .replace(/":"/g, "=")
      //   .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          this.uploadInfo = {
            images: res.data.data.reverse(),
            current: {
              upload: [],
            },
          };
          let tempImage = [];
          let tempIndex = [];
          let tempUpload = [];
          // let tempPhotos =
          //   this.infoImage && this.infoImage["root"]
          //     ? this.info[this.infoImage["root"]]
          //     : [];
          let tempPhotos = [];
          for (let j in this.info.photos ||
            this.info.sliderSlides ||
            tempPhotos) {
            for (let i in this.uploadInfo.images) {
              if (
                (this.info.photos &&
                  this.uploadInfo.images[i].uploadName ==
                  this.info.photos[j]) ||
                (this.info.sliderSlides &&
                  this.uploadInfo.images[i].uploadName ==
                  this.info.sliderSlides[j]) ||
                (tempPhotos &&
                  this.uploadInfo.images[i].uploadName == tempPhotos[j])
              ) {
                tempIndex.push(this.info.id);
                tempImage.push(this.uploadInfo.images[i].uploadName);
                tempUpload.push(Number(i));
                break;
              }
            }
          }
          this.uploadInfo.current = {
            index: tempIndex,
            image: tempImage,
            upload: tempUpload,
          };
          this.modalDisplay = true;
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        });
    },
    detectTabKey() {
      //
      // if (e.keyCode == 9) {
      //   let activeElem = document.activeElement;
      // }
    },
    setSelectedUpload(index, option) {
      this.info["blogTemplate"] = index;

      if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47') {
        this.templateOption = option
        this.templateOption['status'] = true
      }
    },
    setRadioGroup(name, value) {
      this.info[name] = value;
    },
    deleteFilePhoto(index) {
      this.info[index] = "";
      let avatar = `${this.backendHost}/uploads/${this.$store.state.uploadsPath}/1616284800000_Avatar.png`;
      document.getElementById("photoPreview").setAttribute("src", avatar);
    },
    countDownTimer() {
      if (this.countDown == 0) {
        this.verifyTimerSwitch();
      } else {
        if (this.countDown > 0) {
          setTimeout(() => {
            this.countDown -= 1;
            this.countDownTimer();
          }, 1000);
        }
      }
    },
    softBox(src) {
      this.softBoxSource = `${this.backendHost}/uploads/${this.$store.state.uploadsPath}/${src}`;
      this.toggler = !this.toggler;
    },
    verifyTimerSwitch() {
      this.verifyTime = !this.verifyTime;
    },
    goto() {
      if (this.firstErrorName && this.firstErrorName.length > 0) {
        this.$refs[this.firstErrorName][0].scrollIntoView({
          behavior: "smooth",
        });
        if (
          !this.focusStatus &&
          this.$refs[`${this.firstErrorName}_Input`] &&
          this.$refs[`${this.firstErrorName}_Input`].length > 0
        ) {
          this.$refs[`${this.firstErrorName}_Input`][0].focus();
          this.focusStatus = true;
        }
      }
    },
    nestedAccordion(parentId, accordionId) {
      console.log(parentId);
      console.log(accordionId);
      let children = document.querySelectorAll(
        `[data-bs-parent='#${parentId}']`
      );
      children.forEach((element) => {
        element.classList.remove("show");
        if (`#${element.id}` != accordionId) {
          console.log(accordionId);
          console.log(element.id);

          console.log(document.getElementById(`${element.id}_button`));
          document
            .getElementById(`${element.id}_button`)
            .classList.add("collapsed");
        }
      });
      // for(let child in childs){
      //   console.log(childs[child].id)
      //   console.log(document.querySelector(`[data-bs-target='#${childs[child].id}']`))
      //     childs[child].classList.remove('show')
      //   // if(childs[child].id != accordionId){
      //   //   document.querySelectorAll(`[data-bs-target='#${childs[child].id}']`)[0].classList.add('collapsed')
      //   //   // document.querySelectorAll(`[data-bs-target='#${childs[child].id}']`)[1].classList.add('collapsed')
      //   // }
      // }
    },
    createVidisciVideo() {
      console.log("VidiSci Save Function")
    },
    changeCustomStep(status, index) {
      if (status == 'next') {
        this.generalStep += 1;
      } else if (status == 'previous') {
        this.generalStep -= 1;
      } else {
        this.generalStep = index;
      }
    },
  },
  mounted() {
    this.tinyMCE_Def.directionality = this.editorDirection
    if (this.$store.state.projectUUID == '5a1b6cb050e9491ab148196676c58f47' && this.contents.title == "Video") {
      this.generalStep = 0
    }
    // if (this.dropzoneCounter == 0) {
    //   this.dropzoneInput();
    //   this.dropzoneCounter += 1;
    // }
    // if (this.stepType && this.stepType == "wizard") {
    //   this.hafezliNewObj.categories = this.contents.fields[4].options
    //   this.hafezliNewObj.tags = this.contents.fields[5].options
    // }
    if (!this.modalInfo.status) {
      // this.hafezliNewObj.info = []
      // this.hafezliNewObj.info.push({
      //   files: this.modalInfo.productPhotos,
      //   title: this.modalInfo.productName,
      //   summary: this.modalInfo.productSummary,
      //   price: this.modalInfo.productPrice,
      //   teacher: "",
      //   category: this.modalInfo.productCategory,
      //   tags: this.modalInfo.productTags,
      //   description: this.modalInfo.productReview
      // })

      this.hafezliNewObj.info = this.modalInfo

      for (let i in this.modalInfo) {
        if (i > 1) {
          this.hafezliNewObj.steps.push({
            title: 'Activity',
            name: 'chapterInfo',
            sessions: [
              {
                id: '1',
                title: 'Lead-in (Engage)',
                name: 'lead'
              },
              {
                id: '2',
                title: 'Task (Study)',
                name: 'tasks'
              },
              {
                id: '3',
                title: 'Follow-up (Activate)',
                name: 'followUp'
              }
            ]
          })
        }
      }

      console.log(this.hafezliNewObj)
      // this.hafezliCoursesObj.courseAttachment = this.modalInfo.productPhotos;
      // this.hafezliCoursesObj.courseTitle = this.modalInfo.productName;
      // this.hafezliCoursesObj.courseSummary = this.modalInfo.productSummary;
      // this.hafezliCoursesObj.courseCategory = this.modalInfo.productCategory;
      // this.hafezliCoursesObj.courseTags = this.modalInfo.productTags;
      // this.hafezliCoursesObj.coursePrice = this.modalInfo.productPrice;
      // this.hafezliCoursesObj.courseDescription = this.modalInfo.productReview;
      // this.hafezliCoursesObj.courseSessions = this.info.status
      //   ? []
      //   : this.modalInfo.productChapters;
    }
    Object.assign(this.info, this.modalInfo);

    document.body.appendChild(this.modalOverlay);
    this.displayStatus = true;

    if (this.info.status) {
      for (let field in this.contents.fields) {
        if (
          this.contents.fields[field].type == "array" ||
          this.contents.fields[field].type == "component" ||
          this.contents.fields[field].type == "paragraph" ||
          this.contents.fields[field].type == "multiselect" ||
          this.contents.fields[field].type == "card"
        ) {
          continue;
        } else {
          console.log(this.contents.fields[field]);
          this.info[this.contents.fields[field].name] = this.contents.fields[
            field
          ].default
            ? this.contents.fields[field].default
            : "";
        }
      }
    }
    if (
      this.contents.title.includes("Products") &&
      (this.$store.state.shopType == "simple" ||
        this.$store.state.shopType == "custom")
    ) {
      this.pac = false;
    }
    this.info["display"] = true;
    this.modalNode.classList.add("show");
    this.modalNode.classList.add("d-block");
    this.bodyNode.classList.add("modal-open");
    this.bodyNode.style.overflow = "hidden";
  },
  unmounted() {
    try {
      document.body.removeChild(
        document.getElementsByClassName("drawer-overlay")[
        document.getElementsByClassName("drawer-overlay").length - 1
        ]
      );
    } catch (error) {
      console.log("Here");
      console.log(error);
    }
    this.bodyNode.style.overflow = "";
  },
  updated() {
    //
    if (this.enableTimer && !this.verifyTime) {
      this.verifyTime = true;
      this.countDown = 5;
      this.countDownTimer();
    }
    if (this.dropzoneCounter == 0) {
      this.dropzoneInput();
      this.dropzoneCounter += 1;
    }

    this.goto();
  },
  created() {
    this.countDownTimer();
  },
};
</script>

<style scoped>
input::placeholder,
input::-moz-placeholder,
input::-webkit-input-placeholder {
  text-align: start !important;
}

.mh-50vh {
  max-height: 63vh !important;
}

@media (min-width: 1000px) {
  .border-top-lg-0 {
    border-top: 0 !important;
  }
}

.wrong-inputs {
  border: 2px solid !important;
  border-color: red !important;
  /* background-color: #fff; */
}

/*========== SCROLL BAR ==========*/
.modal-body::-webkit-scrollbar {
  width: 0.7rem;
  background-color: var(--scroll-bar-color);
  border-radius: 0.5rem;
}

.modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-primary-rgb), 0.6);
  border-radius: 0.5rem;
}

.modal ::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.9);
}

.card:has([data-bs-parent="#chapterAccordion"].collapse.show) {
  border-color: var(--bs-primary) !important;
  box-shadow: 0 0 20px 0 rgba(var(--bs-primary-rgb), 0.5);
}

.card:has([data-bs-parent="#chapterAccordion"].collapse.show)>div:first-child {
  background-color: rgba(var(--bs-primary-rgb), 0.5) !important;
}

button::before {
  font-size: 1.2rem;
}
</style>
